export const COUNTRIES = {
  usa: {
    code: 'usa',
    name: 'United States',
    subdomain: 'us',
    languages: ['en-US'],
    defaultLanguage: 'en-US',
    currency: 'USD',
    price: 29.99,
    flag: '🇺🇸',
    regions: ['California', 'Texas', 'Florida', 'New York'],
  },
  canada: {
    code: 'canada',
    name: 'Canada',
    subdomain: 'ca',
    languages: ['en-CA', 'fr-CA'],
    defaultLanguage: 'en-CA',
    currency: 'CAD',
    price: 39.99,
    flag: '🇨🇦',
    regions: ['Ontario', 'Quebec', 'British Columbia', 'Alberta'],
  },
  france: {
    code: 'france',
    name: 'France',
    subdomain: 'fr',
    languages: ['fr-FR'],
    defaultLanguage: 'fr-FR',
    currency: 'EUR',
    price: 29.99,
    flag: '🇫🇷',
    regions: ['Île-de-France', 'Provence', 'Bretagne', 'Nouvelle-Aquitaine'],
  },
  germany: {
    code: 'germany',
    name: 'Germany',
    subdomain: 'de',
    languages: ['de-DE'],
    defaultLanguage: 'de-DE',
    currency: 'EUR',
    price: 29.99,
    flag: '🇩🇪',
    regions: ['Bayern', 'Nordrhein-Westfalen', 'Baden-Württemberg', 'Hessen'],
  },
  italy: {
    code: 'italy',
    name: 'Italy',
    subdomain: 'it',
    languages: ['it-IT'],
    defaultLanguage: 'it-IT',
    currency: 'EUR',
    price: 29.99,
    flag: '🇮🇹',
    regions: ['Lazio', 'Lombardia', 'Campania', 'Sicilia'],
  },
  uk: {
    code: 'uk',
    name: 'United Kingdom',
    subdomain: 'uk',
    languages: ['en-GB'],
    defaultLanguage: 'en-GB',
    currency: 'GBP',
    price: 24.99,
    flag: '🇬🇧',
    regions: ['England', 'Scotland', 'Wales', 'Northern Ireland'],
  },
  australia: {
    code: 'australia',
    name: 'Australia',
    subdomain: 'au',
    languages: ['en-AU'],
    defaultLanguage: 'en-AU',
    currency: 'AUD',
    price: 44.99,
    flag: '🇦🇺',
    regions: ['New South Wales', 'Victoria', 'Queensland', 'Western Australia'],
  },
  spain: {
    code: 'spain',
    name: 'Spain',
    subdomain: 'es',
    languages: ['es-ES'],
    defaultLanguage: 'es-ES',
    currency: 'EUR',
    price: 24.99,
    flag: '🇪🇸',
    regions: ['Madrid', 'Cataluña', 'Andalucía', 'Valencia'],
  },
};

export const LANGUAGES = {
  'en-US': { name: 'English (US)', nativeName: 'English' },
  'en-CA': { name: 'English (Canada)', nativeName: 'English' },
  'fr-CA': { name: 'French (Canada)', nativeName: 'Français' },
  'fr-FR': { name: 'French (France)', nativeName: 'Français' },
  'de-DE': { name: 'German', nativeName: 'Deutsch' },
  'it-IT': { name: 'Italian', nativeName: 'Italiano' },
  'en-GB': { name: 'English (UK)', nativeName: 'English' },
  'en-AU': { name: 'English (Australia)', nativeName: 'English' },
  'es-ES': { name: 'Spanish (Spain)', nativeName: 'Español' },
};

export const getCountryByCode = (code) => COUNTRIES[code];
export const getAllCountries = () => Object.values(COUNTRIES);
export const getLanguageInfo = (langCode) => LANGUAGES[langCode];
